/* ==========================================================================
   RIWAAYAT — Product page
   Variant resolution, price/MRP/savings, availability, gallery (swipe + dots
   + lightbox), add-to-bag / buy-now, sticky CTA, tabs ink.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-rw-product]');
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  if (root) initProduct(root);
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-rw-copy]');
    if (!c) return;
    var code = c.getAttribute('data-rw-copy');
    var done = function () {
      c.classList.add('is-copied');
      var orig = c.textContent; c.textContent = 'Copied';
      window.rwToast && window.rwToast('Code ' + code + ' copied — apply at checkout');
      setTimeout(function () { c.classList.remove('is-copied'); c.textContent = orig; }, 1800);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });
  initTabs();
  initRecommendations();
  initRecentlyViewed();

  function initProduct(root) {
    var dataEl = document.querySelector('[data-rw-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var money = window.rwMoney || function (c) { return (c / 100).toFixed(0); };
    var form = root.querySelector('[data-rw-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var qtyInput = form && form.querySelector('[data-rw-qty-input]');
    var addBtn = root.querySelector('[data-rw-add]');
    var buyBtn = root.querySelector('[data-rw-buy]');
    var sticky = document.querySelector('.rw-sticky');
    var stickyAdd = sticky && sticky.querySelector('[data-rw-sticky-add]');
    var stickyBuy = sticky && sticky.querySelector('[data-rw-sticky-buy]');
    var lowStock = parseInt(root.getAttribute('data-low-stock') || '3', 10);

    var current = product.variants.find(function (v) { return String(v.id) === String(idInput && idInput.value); }) || product.variants[0];

    /* --- Option pills --- */
    function selectedOptions() {
      return product.options.map(function (_, i) {
        var checked = root.querySelector('input[data-option-index="' + i + '"]:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
    }
    function markAvailability() {
      var opts = selectedOptions();
      $$('input[data-option-index]', root).forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var test = opts.slice(); test[idx] = input.value;
        var v = findVariant(test);
        input.closest('.rw-pill').classList.toggle('is-unavailable', !v || !v.available);
      });
    }

    function update(v, fromUser) {
      current = v;
      var sold = !v || !v.available;
      if (idInput && v) idInput.value = v.id;

      /* Price block */
      $$('[data-rw-price]').forEach(function (el) { el.textContent = v ? money(v.price) : ''; });
      var hasCompare = v && v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-rw-mrp-wrap]').forEach(function (el) { el.hidden = !hasCompare; });
      $$('[data-rw-mrp]').forEach(function (el) { el.textContent = hasCompare ? money(v.compare_at_price) : ''; });
      $$('[data-rw-save]').forEach(function (el) {
        el.hidden = !hasCompare;
        if (hasCompare) el.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
      });
      var best = root.querySelector('[data-rw-best]');
      if (best && v && product.couponPercent > 0) best.textContent = money(Math.round(v.price - (v.price * product.couponPercent) / 100));
      $$('[data-rw-option-label]', root).forEach(function (el) {
        var i = parseInt(el.getAttribute('data-rw-option-label'), 10);
        el.textContent = v ? v.options[i] : '';
      });

      /* Stock */
      var stock = root.querySelector('[data-rw-stock]');
      if (stock) {
        var qty = v && typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null;
        var tracked = v && v.inventory_management === 'shopify' && v.inventory_policy !== 'continue';
        stock.classList.remove('is-low', 'is-out');
        var label = stock.querySelector('span');
        if (sold) { stock.classList.add('is-out'); label.textContent = 'Sold out — ask us on WhatsApp for a restock'; }
        else if (tracked && qty !== null && qty > 0 && qty <= lowStock) { stock.classList.add('is-low'); label.textContent = qty === 1 ? 'Only one piece left — a true one-of-one' : 'Only ' + qty + ' pieces left'; }
        else label.textContent = 'In stock';
      }

      /* Buttons */
      [addBtn, stickyAdd].forEach(function (b) {
        if (!b) return;
        b.disabled = sold;
        var l = b.querySelectorAll('.rw-btn__label span');
        l.forEach(function (s) { s.textContent = sold ? 'Sold out' : (b.getAttribute('data-label') || 'Add to bag'); });
      });
      [buyBtn, stickyBuy].forEach(function (b) { if (b) b.hidden = sold; });

      /* URL */
      if (fromUser && v && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      /* Media */
      if (v && v.featured_media) {
        var target = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (target) {
          var grid = target.parentElement;
          if (window.matchMedia('(max-width: 989px)').matches) grid.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          else if (grid.firstElementChild !== target) {
            grid.insertBefore(target, grid.firstElementChild);
          }
        }
      }
      markAvailability();
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[data-option-index]')) return;
      update(findVariant(selectedOptions()), true);
    });

    /* --- Quantity --- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rw-step]');
      if (!b || !qtyInput) return;
      var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-rw-step'), 10));
      qtyInput.value = n;
    });

    /* --- Add / buy --- */
    function add(checkout, btn) {
      if (!current || !current.available) return;
      var q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      btn && btn.classList.add('is-loading');
      var props = {};
      $$('[name^="properties["]', form).forEach(function (el) {
        if (el.value) props[el.name.slice(11, -1)] = el.value;
      });
      var item = { id: current.id, quantity: q };
      if (Object.keys(props).length) item.properties = props;
      return window.rwAdd([item], { checkout: checkout })
        .then(function () {
          if (!checkout && window.rwToast) window.rwToast('Added to your bag');
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { sourceId: 'rw-product', data: { source: 'rw-product', itemCount: q } } }));
        })
        .catch(function (err) { window.rwToast && window.rwToast(err.message); })
        .finally(function () { btn && btn.classList.remove('is-loading'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(false, addBtn); });
    if (buyBtn) buyBtn.addEventListener('click', function (e) { e.preventDefault(); add(true, buyBtn); });
    if (stickyAdd) stickyAdd.addEventListener('click', function (e) { e.preventDefault(); add(false, stickyAdd); });
    if (stickyBuy) stickyBuy.addEventListener('click', function (e) { e.preventDefault(); add(true, stickyBuy); });

    /* --- Sticky CTA: visible once the main CTA scrolls above the viewport,
           hidden again when the footer arrives --- */
    if (sticky && addBtn) {
      var footer = document.querySelector('.rw-footer');
      var ticking = false;
      var sync = function () {
        ticking = false;
        var ctaGone = addBtn.getBoundingClientRect().bottom < 0;
        var footerIn = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        var on = ctaGone && !footerIn;
        if (sticky.classList.contains('is-visible') !== on) {
          sticky.classList.toggle('is-visible', on);
          document.body.classList.toggle('rw-has-sticky-atc', on);
        }
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(sync); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      sync();
    }

    /* --- Gallery: thumb rail, arrows, counter --- */
    var grid = root.querySelector('.rw-gallery__grid');
    var thumbs = $$('[data-rw-thumb]', root);
    var count = root.querySelector('.rw-gallery__count');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var currentIndex = function () { return grid ? Math.round(grid.scrollLeft / Math.max(1, grid.clientWidth)) : 0; };
    var goTo = function (i) {
      if (!grid) return;
      var n = grid.children.length;
      i = (i + n) % n;
      grid.scrollTo({ left: i * grid.clientWidth, behavior: 'smooth' });
    };
    if (grid) {
      var syncGal = function () {
        var i = currentIndex();
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
        if (count) count.textContent = pad(i + 1) + ' / ' + pad(grid.children.length);
      };
      grid.addEventListener('scroll', function () { window.requestAnimationFrame(syncGal); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-rw-thumb'), 10)); }); });
      $$('[data-rw-gal]', root).forEach(function (b) { b.addEventListener('click', function () { goTo(currentIndex() + parseInt(b.getAttribute('data-rw-gal'), 10)); }); });
    }

    /* --- Share --- */
    var share = root.querySelector('[data-rw-share]');
    if (share) share.addEventListener('click', function () {
      var data = { title: document.title, url: window.location.href.split('?')[0] };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () { window.rwToast && window.rwToast('Link copied'); });
    });

    /* --- Gift note --- */
    var gift = root.querySelector('[data-rw-gift]');
    if (gift) {
      var toggle = gift.querySelector('[data-rw-gift-toggle]');
      var note = gift.querySelector('textarea');
      toggle.addEventListener('change', function () {
        gift.classList.toggle('is-on', toggle.checked);
        note.disabled = !toggle.checked;
        if (toggle.checked) note.focus(); else note.value = '';
      });
    }

    /* --- Pincode delivery estimate (configurable range, shown as an estimate) --- */
    var pin = root.querySelector('[data-rw-pincode]');
    if (pin) {
      var pinInput = pin.querySelector('input');
      var pinMsg = pin.querySelector('.rw-pincode__msg');
      var minD = parseInt(root.getAttribute('data-ship-min') || '4', 10);
      var maxD = Math.max(minD, parseInt(root.getAttribute('data-ship-max') || '7', 10));
      var fmt = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var check = function () {
        var v = (pinInput.value || '').replace(/\D/g, '');
        pinInput.value = v;
        pinMsg.classList.remove('is-ok', 'is-err');
        if (!/^[1-9][0-9]{5}$/.test(v)) { pinMsg.classList.add('is-err'); pinMsg.textContent = 'Please enter a valid 6-digit pincode.'; return; }
        var a = new Date(); a.setDate(a.getDate() + minD);
        var b = new Date(); b.setDate(b.getDate() + maxD);
        pinMsg.classList.add('is-ok');
        pinMsg.textContent = 'Estimated delivery to ' + v + ': ' + fmt(a) + ' – ' + fmt(b);
        try { localStorage.setItem('rw-pin', v); } catch (e) {}
      };
      pin.querySelector('[data-rw-pin-check]').addEventListener('click', check);
      pinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
      try { var saved = localStorage.getItem('rw-pin'); if (saved) { pinInput.value = saved; check(); } } catch (e) {}
    }

    /* --- Lightbox --- */
    var lb = document.querySelector('.rw-lightbox');
    if (lb && grid) {
      var track = lb.querySelector('.rw-lightbox__track');
      grid.addEventListener('click', function (e) {
        var item = e.target.closest('.rw-gallery__item');
        if (!item || item.querySelector('video, model-viewer, iframe')) return;
        var items = $$('.rw-gallery__item', grid);
        track.innerHTML = items.map(function (it) {
          var im = it.querySelector('img');
          return im ? '<figure><img src="' + (im.getAttribute('data-zoom') || im.currentSrc || im.src) + '" alt="' + (im.alt || '') + '"></figure>' : '';
        }).join('');
        lb.classList.add('is-open'); window.rwLock && window.rwLock(true);
        var idx = items.indexOf(item);
        requestAnimationFrame(function () { track.scrollLeft = idx * track.clientWidth; });
      });
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-rw-lightbox-close]') || e.target.tagName === 'FIGURE') { lb.classList.remove('is-open'); window.rwLock && window.rwLock(false); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) { lb.classList.remove('is-open'); window.rwLock && window.rwLock(false); } });
    }

    update(current);
  }

  /* --- Tabs with sliding ink --- */
  function initTabs() {
    $$('[data-rw-ptabs]').forEach(function (wrap) {
      var btns = $$('.rw-ptabs__btn', wrap);
      var ink = wrap.querySelector('.rw-ptabs__ink');
      var move = function (b) { if (!ink || !b) return; ink.style.width = b.offsetWidth + 'px'; ink.style.transform = 'translateX(' + b.offsetLeft + 'px)'; };
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
          $$('.rw-ptabs__panel', wrap).forEach(function (p) { p.hidden = p.id !== b.getAttribute('aria-controls'); });
          move(b);
        });
      });
      move(btns[0]);
      window.addEventListener('resize', function () { move(wrap.querySelector('.rw-ptabs__btn[aria-selected="true"]')); });
    });
  }

  /* --- Recommendations (lazy, section rendering) --- */
  function initRecommendations() {
    $$('[data-rw-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      var load = function () {
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-rw-recs]');
          if (fresh && fresh.querySelector('.rw-card')) {
            el.innerHTML = fresh.innerHTML;
            el.closest('.rw-section') && el.closest('.rw-section').removeAttribute('hidden');
            if (window.gsap) window.gsap.fromTo(el.querySelectorAll('.rw-card'), { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 0.9, stagger: 0.08, ease: 'power3.out' });
            document.dispatchEvent(new CustomEvent('rw:rail:refresh'));
          } else {
            var sec = el.closest('.shopify-section'); if (sec) sec.style.display = 'none';
          }
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
        io.observe(el);
      } else load();
    });
  }

  /* --- Recently viewed (localStorage handles; renders via search view) --- */
  function initRecentlyViewed() {
    var KEY = 'rw-recent';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var current = document.querySelector('[data-rw-product]');
    var handle = current && current.getAttribute('data-handle');
    if (handle) {
      list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    $$('[data-rw-recent]').forEach(function (el) {
      var show = list.filter(function (h) { return h !== handle; }).slice(0, 8);
      var sec = el.closest('.shopify-section');
      if (!show.length) { if (sec) sec.style.display = 'none'; return; }
      Promise.all(show.map(function (h) {
        return fetch((window.rwRoutes && window.rwRoutes.root || '/').replace(/\/$/, '') + '/products/' + h + '?view=rw-card')
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (htmls) {
        var cards = htmls.filter(function (h) { return h.indexOf('rw-card') > -1; });
        if (!cards.length) { if (sec) sec.style.display = 'none'; return; }
        el.innerHTML = cards.join('');
        document.dispatchEvent(new CustomEvent('rw:rail:refresh'));
      });
    });
  }
})();
